<template>
  <div>
    <b-carousel
      id="carousel1"
      controls
      indicators
      :interval="3000"
      v-model="slide"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
      class="m-0"
    >
      <b-carousel-slide
        class="img-fluid"
        v-for="(destaque, index) in destaques"
        :key="destaque.index"
        :caption="destaque.index"
        :img-src="destaque.url"
      >
      </b-carousel-slide>
    </b-carousel>
    <!--<div>-->
      <!--<p class="descricao">-->
       <!--{{ descricao }}-->
      <!--</p>-->
    <!--</div>-->
  </div>
</template>

<script>
  import dashboard from '@/services/dashboard'
  export default {
    data () {
      return {
        destaques: [],
        slide: 0,
        descricao: ''
      }
    },
    methods: {
      onSlideStart (index) {
        let descricao = this.destaques[index].descricao
        this.descricao = descricao
      },
      onSlideEnd (index) {
        let descricao = this.destaques[index].descricao
        this.descricao = descricao
      }
    },
    mounted () {
      dashboard.listarDashboard().then(response => {
        this.destaques = response.data.destaques
      })
    }
  }
</script>
<style scoped>
  .descricao{
    font-size: 9px;
    font-weight: 900;
  }
  .img-fluid {
    max-width: 100%;
    height: 300px;
  }

</style>




// WEBPACK FOOTER //
// src/components/items/CarouselVue.vue